/*
 * Page Name
 */

(function ($) {

    _heightline({
        itemClsName: '.office_fancybox_link p a',
        itemPerRow: 3,
        device: 'smp'
    });

    var office_area = jQuery('.office_category li');
    var office_area_content = jQuery('.office_category_area');
    var map_area_anchor = jQuery('.map_area_scrollto');

    if (office_area.length > 0) {
        office_area.on('click', function (e) {
            e.preventDefault();
            var _this_area = jQuery(this);
            var _target_area = _this_area.data('area');

            office_area.removeClass("active");
            office_area_content.removeClass("active");

            _this_area.toggleClass("active");
            jQuery('.office_category_area[data-area="' + _target_area + '"]').toggleClass("active");
        });
    }

    /* map area scrollto */
    if (map_area_anchor.length > 0) {
        map_area_anchor.find('area').on('click', function (e) {
            var _target_area = jQuery(this).attr('title');
            var _target_scroll = jQuery(this).attr('href');
            var area_tab = jQuery('.office_category li[data-area="' + _target_area + '"]');
            var area_content = jQuery('.office_category_area[data-area="' + _target_area + '"]');

            if (_target_scroll != '#anchor_area_mainoffice') {
                office_area.removeClass("active");
                office_area_content.removeClass("active");
                area_tab.toggleClass("active");
                area_content.toggleClass("active");
            }
            jQuery("html, body").animate({ scrollTop: jQuery(_target_scroll).offset().top - jQuery('header').height() - 20 }, 300);
        });
    }

    if (is_smp) {
        jQuery('#image-mapsmp').mapster({
            singleSelect: true,
            clickNavigate: true,
            render_highlight: { altImage: path_media + 'office-map-smp_on.png' },
            mapKey: 'gp',
            fillOpacity: 1,
        });
    } else {
        jQuery('#image-map').mapster({
            singleSelect: true,
            clickNavigate: true,
            render_highlight: { altImage: path_media + 'office-map_on.png' },
            mapKey: 'gp',
            fillOpacity: 1,
        });
    }


})(jQuery);